import { mergeClassNames } from "../../utils/classes";
import Icon from "../Icon/Icon";

import * as styles from "./toggleSwitch.module.scss";

export interface ToggleSwitchProps {
	checked: boolean;
	onChange: (value: boolean) => void;
	/**
	 * @deprecated Should only be used for design system internal overrides.
	 */
	className?: string;
	testId?: string;
	disabled?: boolean;
}

export const ToggleSwitch = ({ checked, onChange, className, testId, disabled }: ToggleSwitchProps) => {
	const labelClass = mergeClassNames(
		styles.label,
		checked && styles.active,
		disabled && styles.disabled,
		checked && disabled && styles.activeDisabled,
	);

	const handleChange = () => {
		if (!disabled) {
			onChange(!checked);
		}
	};

	return (
		<label className={mergeClassNames(labelClass, className)} data-testid={testId}>
			<input type="checkbox" className={styles.input} onChange={handleChange} checked={checked} disabled={disabled} />
			{checked ? (
				<span className={styles.labelYes}>
					<Icon name="check" size="18" />
				</span>
			) : (
				<span className={mergeClassNames(styles.labelNo, disabled && styles.labelNoDisabled)}>
					<Icon name="cancel" size="18" />
				</span>
			)}
		</label>
	);
};
